import { tFunction } from 'app/lang';

import dictionary from './Body.dictionary.json';

type Dict = {
  label: string;
  placeholder: string;
};

export const getDictionary = (t: tFunction, variant: 'city' | 'vatNumber' | 'email'): Dict => {
  switch (variant) {
    case 'city':
      return {
        label: t(dictionary.cityLabel),
        placeholder: t(dictionary.cityPlaceholder),
      };
    case 'vatNumber':
      return {
        label: t(dictionary.vatNumberLabel),
        placeholder: t(dictionary.vatNumberPlaceholder),
      };
    case 'email':
      return {
        label: t(dictionary.emailLabel),
        placeholder: t(dictionary.emailPlaceholder),
      };

    default:
      console.error('Cover this variant with a dict');
      return {
        label: '',
        placeholder: '',
      };
  }
};
